import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'
import { monthFormat } from '@/filters'
const dayAttendance = {
  title: '日缺勤人员列表',
  name: 'dayAttendance',
  rowKey: 'personUid',
  headButtons: (params) => {
    const isAdmin =
      params.orgValue === params.state.queryValues.laborAttendance.upVproUid
    const confirmed = params.state.attendance.attendanceIsSure === '已确认'
    return isAdmin && !confirmed ? setCheckButtons(['批量打卡']) : []
  },
  tagInfo: (params) => {
    if (params.state.attendance.attendanceIsSure === '已确认') {
      return '该月考勤已确认，仅可查看不可打卡'
    }
    return params.orgValue ===
      params.state.queryValues.laborAttendance.upVproUid
      ? ''
      : '你没有修改该机构人员考勤的权限！'
  },
  tagType: (params) => {
    if (params.state.attendance.attendanceIsSure === '已确认') {
      return 'success'
    }
    return params.orgValue ===
      params.state.queryValues.laborAttendance.upVproUid
      ? ''
      : 'danger'
  },
  selectColumn: (params) => {
    return (
      params.orgValue ===
        params.state.queryValues.laborAttendance.upVproUid &&
      params.state.attendance.attendanceIsSure !== '已确认'
    )
  },
  getListFun: 'attendance/getOrgDayAbsent',
  getParentFun: (params) => {
    return params.state.attendance.statisticsType === 'bidSection'
      ? 'attendance/getLaborOrgDayAttendance'
      : 'attendance/getAttendance'
  },
  rowData: (params) => {
    return params.state.attendance.orgDayAbsent
  },
  columns: [
    {
      prop: 'name',
      label: '人员姓名',
      width: (params) => {
        return params.orgValue ===
          params.state.queryValues.laborAttendance.upVproUid
          ? '200px'
          : ''
      }
    },
    {
      prop: 'isClock',
      label: '出勤状态',
      width: (params) => {
        return params.orgValue ===
          params.state.queryValues.laborAttendance.upVproUid
          ? '200px'
          : ''
      }
    },
    {
      prop: 'isConf',
      label: '是否确认',
      width: (params) => {
        return params.orgValue ===
          params.state.queryValues.laborAttendance.upVproUid
          ? '200px'
          : ''
      }
    },
    {
      label: '操作',
      buttons: (params) => {
        const isAdmin =
          params.orgValue ===
          params.state.queryValues.laborAttendance.upVproUid
        const confirmed =
          params.state.attendance.attendanceIsSure === '已确认'
        return isAdmin && !confirmed ? setTableButtons(['打卡']) : []
      }
    }
  ],
  hasFooter: false
}
const batchClock = {
  title: '人员月缺勤列表',
  name: 'batchClock',
  rowKey: 'useDate',
  headButtons: setCheckButtons(['批量打卡']),
  selectColumn: true,
  getListFun: 'attendance/getAttendance',
  rowData: (params) => {
    return params.getters['attendance/batchClockData']
  },
  columns: [
    { prop: 'useDate', label: '出勤日期', width: '' },
    { prop: 'isClock', label: '出勤状态', width: '' },
    {
      label: '操作',
      buttons: setTableButtons(['打卡'])
    }
  ],
  hasFooter: false
}
const upLoadAttendance = {
  title: '导入考勤',
  name: 'upLoadAttendance',
  upload: true,
  rowKey: 'index',
  upLoadFun: 'attendance/upLoadAttendance',
  getParentFun: 'attendance/getAttendance',
  columns: [
    { prop: 'name', label: '人员姓名', width: '130px' },
    { prop: 'attendance', label: '出勤天数', width: '150px' },
    { prop: 'absence', label: '缺勤天数', width: '220px' },
    { prop: 'status', label: '数据状态', width: '160px' },
    {
      label: '操作',
      buttons: setTableButtons(['删除'])
    }
  ]
}
const attendance = {
  pageTabs: [
    {
      label: '劳务考勤',
      theme: 'attendance',
      step: 'laborAttendanceCale',
      stepLabel: '劳务人员考勤',
      checkFun: 'attendance/getAttendance'
    },
    {
      label: '管理考勤',
      theme: 'attendance',
      step: 'manageAttendanceCale',
      stepLabel: '管理考勤列表',
      checkFun: 'attendance/getAttendance'
    }
  ],
  laborAttendance: {
    name: 'laborAttendance',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'calendars',
      'dialogTable',
      'drawerTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'attendance/getAttendance',
    confirmFun: 'attendance/confirmAttendance',
    detailPage: [
      {
        buttonName: (params) => {
          return params.state.attendance.statisticsType !== 'person'
            ? '点击日历'
            : null
        },
        type: (params) => {
          return params.state.attendance.statisticsType === 'bidSection'
            ? 'drawerTable'
            : 'dialogTable'
        },
        name: (params) => {
          return params.state.attendance.statisticsType === 'bidSection'
            ? 'dayAttendanceSum'
            : 'dayAttendance'
        },
        checkFun: (params) => {
          return params.state.attendance.statisticsType === 'bidSection'
            ? 'attendance/getLaborOrgDayAttendance'
            : 'attendance/getOrgDayAbsent'
        },
        expandAll: true
      },
      {
        buttonName: '批量缺勤打卡',
        type: 'dialogTable',
        name: 'batchClock'
      },
      {
        buttonName: '导入考勤',
        type: 'dialogTable',
        name: 'upLoadAttendance'
      }
    ],
    headButtons: (params) => {
      const isAdmin =
        params.queryValues && params.orgValue === params.queryValues.upVproUid
      const type = params.state.attendance.statisticsType
      const isSure = params.state.attendance.attendanceIsSure
      if (!isAdmin) return []
      if (type === 'person') {
        return isSure === '已确认' ? [] : setCheckButtons(['批量缺勤打卡'])
      }
      // 标段级不可导入劳务考勤，须选到劳务公司
      if (type === 'bidSection') return []
      // 已确认后仍可导入覆盖；未确认时还可点确认考勤
      if (isSure === '未确认') {
        return setCheckButtons(['确认考勤', '导入考勤', '下载导入模板'])
      }
      return setCheckButtons(['导入考勤', '下载导入模板'])
    },
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      upVproUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      downVproUid: '',
      personUid: '',
      monthTime: monthFormat(new Date())
    },
    selectData: [
      {
        key: 'upVproUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'downVproUid',
        label: '所属劳务公司',
        type: 'select',
        placeholder: '请先选择项目标段后再选择',
        options: (params) => {
          return params.state.bidSection.laborCompanyNames
        },
        filterable: true,
        checkByValue: true
      },
      {
        key: 'personUid',
        label: '劳务人员',
        type: 'select',
        placeholder: '请先选择劳务公司后再选择',
        options: (params) => {
          return params.state.contractor.laborPersonNames
        },
        filterable: true,
        checkByValue: true
      },
      {
        key: 'monthTime',
        label: '统计月份',
        type: 'time',
        timetype: 'month',
        format: 'yyyy-MM',
        clearable: false
      }
    ],
    // 有 tip：105/100；无 tip：整体加高约 30px（按 6 行分摊，每格 +5）
    calendarDayHeight: (params) => {
      const hasTip = !!(
        params.getTagData &&
        params.getTagData(params.isSelectedDay, params.step).tagInfo
      )
      const base =
        params.state.attendance.statisticsType === 'bidSection' ? 105 : 100
      return (hasTip ? base : base + 5) + 'px'
    },
    tagType: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagType
    },
    tagInfo: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagInfo
    },
    tagImg: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagImg
    },
    calendarType: (params) => {
      return params.state.attendance.statisticsType === 'person'
        ? 'asRow'
        : 'asCol'
    },
    tipContent: (params) => {
      const confirmed = params.state.attendance.attendanceIsSure === '已确认'
      if (params.state.attendance.statisticsType === 'person') {
        return confirmed
          ? '考勤已确认不可开关编辑，如需修改请导入覆盖'
          : '点击开关按钮修改考勤'
      }
      return confirmed
        ? '考勤已确认，可导入覆盖本月考核考勤；点击查看出勤详情'
        : '点击查询机构日出勤详情'
    },
    isShould: (params) => {
      return function (day) {
        return params.getters['attendance/getIsShould'](day)
      }
    },
    statusImg: (params) => {
      return function (day) {
        return params.getters['attendance/getAttendanceImg'](day)
      }
    },
    status: (params) => {
      return function (day) {
        return params.getters['attendance/getAttendanceStatus'](day)
      }
    },
    showSwitch: (params) => {
      return !!(
        params.queryValues &&
        params.orgValue === params.queryValues.upVproUid &&
        params.state.attendance.attendanceIsSure !== '已确认'
      )
    },
    matters: (params) => {
      return params.getters['attendance/attendanceMatters']
    },
    dayAttendanceSum: {
      name: 'dayAttendanceSum',
      title: (params) => {
        return params.isSelectedDay + '项目标段日出勤汇总'
      },
      size: '45%',
      direction: 'ltr',
      getListFun: 'attendance/getLaborOrgDayAttendance',
      getDetailFun: 'attendance/getOrgDayAbsent',
      getParentFun: 'attendance/getAttendance',
      rowData: (params) => {
        return params.state.attendance.orgDayAttendance
      },
      detailPage: [
        {
          buttonName: '批量缺勤打卡',
          type: 'dialogTable',
          name: 'dayAttendance',
          checkType: 'checkByRow',
          checkFun: 'attendance/getOrgDayAbsent'
        }
      ],
      hasPagination: false,
      columns: [
        {
          prop: 'label',
          label: '\xa0\xa0\xa0考勤机构名称',
          width: '220px'
        },
        { prop: 'shouldNum', label: '应出勤（人）', width: '' },
        { prop: 'actualNum', label: '实际出勤（人）', width: '' },
        { prop: 'ownNum', label: '缺勤人数（人）', width: '' },
        { prop: 'totalLock', label: '出勤率（%）', width: '' },
        {
          label: '操作',
          width: '120px',
          buttons: setTableButtons(['批量缺勤打卡'])
        }
      ]
    },
    dayAttendance: dayAttendance,
    batchClock: batchClock,
    upLoadAttendance: upLoadAttendance
  },
  manageAttendance: {
    name: 'manageAttendance',
    theme: '管理人员',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'calendars',
      'dialogTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        buttonName: (params) => {
          return params.state.attendance.statisticsType !== 'person'
            ? '点击日历'
            : null
        },
        type: 'dialogTable',
        name: 'dayAttendance',
        checkFun: 'attendance/getOrgDayAbsent'
      },
      {
        buttonName: '批量缺勤打卡',
        type: 'dialogTable',
        name: 'batchClock'
      },
      {
        buttonName: '导入考勤',
        type: 'dialogTable',
        name: 'upLoadAttendance'
      }
    ],
    getListFun: 'attendance/getAttendance',
    confirmFun: 'attendance/confirmAttendance',
    headButtons: (params) => {
      const isAdmin =
        params.queryValues && params.orgValue === params.queryValues.upVproUid
      const type = params.state.attendance.statisticsType
      const isSure = params.state.attendance.attendanceIsSure
      if (!isAdmin) return []
      if (type === 'person') {
        return isSure === '已确认' ? [] : setCheckButtons(['批量缺勤打卡'])
      }
      // 管理考勤在标段级导入；已确认后仍可导入覆盖
      if (isSure === '未确认') {
        return setCheckButtons(['确认考勤', '导入考勤', '下载导入模板'])
      }
      return setCheckButtons(['导入考勤', '下载导入模板'])
    },
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      upVproUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      downVproUid: '',
      personUid: '',
      monthTime: monthFormat(new Date())
    },
    selectData: [
      {
        key: 'upVproUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'personUid',
        label: '管理人员',
        type: 'select',
        placeholder: '请先选择项目标段后再选择',
        options: (params) => {
          return params.state.contractor.managePersonNames
        },
        filterable: true,
        checkByValue: true
      },
      {
        key: 'monthTime',
        label: '统计月份',
        type: 'time',
        timetype: 'month',
        format: 'yyyy-MM',
        clearable: false
      }
    ],
    // 有 tip：105/100；无 tip：整体加高约 30px（按 6 行分摊，每格 +5）
    calendarDayHeight: (params) => {
      const hasTip = !!(
        params.getTagData &&
        params.getTagData(params.isSelectedDay, params.step).tagInfo
      )
      const base =
        params.state.attendance.statisticsType === 'bidSection' ? 105 : 100
      return (hasTip ? base : base + 5) + 'px'
    },
    tagType: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagType
    },
    tagInfo: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagInfo
    },
    tagImg: (params) => {
      return params.getTagData(params.isSelectedDay, params.step).tagImg
    },
    calendarType: (params) => {
      return params.state.attendance.statisticsType === 'person'
        ? 'asRow'
        : 'asCol'
    },
    tipContent: (params) => {
      const confirmed = params.state.attendance.attendanceIsSure === '已确认'
      if (params.state.attendance.statisticsType === 'person') {
        return confirmed
          ? '考勤已确认不可开关编辑，如需修改请导入覆盖'
          : '点击开关按钮修改考勤'
      }
      return confirmed
        ? '考勤已确认，可导入覆盖本月考核考勤；点击查看出勤详情'
        : '点击查询机构日出勤详情'
    },
    isShould: (params) => {
      return function (day) {
        return params.getters['attendance/getIsShould'](day)
      }
    },
    statusImg: (params) => {
      return function (day) {
        return params.getters['attendance/getAttendanceImg'](day)
      }
    },
    status: (params) => {
      return function (day) {
        return params.getters['attendance/getAttendanceStatus'](day)
      }
    },
    showSwitch: (params) => {
      return !!(
        params.queryValues &&
        params.orgValue === params.queryValues.upVproUid &&
        params.state.attendance.attendanceIsSure !== '已确认'
      )
    },
    matters: (params) => {
      return params.getters['attendance/attendanceMatters']
    },
    dayAttendance: dayAttendance,
    batchClock: batchClock,
    upLoadAttendance: upLoadAttendance
  }
}

export default attendance
